export const BUILD_VERSION = '1793835423';
